// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  PRESUPUESTADOR_LIMPIAR_ERRORES_RESUMEN,
} from './constants';

export function limpiarErroresResumen() {
  return {
    type: PRESUPUESTADOR_LIMPIAR_ERRORES_RESUMEN,
    data: {
      saveClientError: "",
      savePresupuestoError: "",
      updateStatePresupuestoError: "",
      getPdfError: "",
      sendEmailError: "",
      controlClientError: ""
    }
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_LIMPIAR_ERRORES_RESUMEN:
      return {
        ...state,
        ...action.data,
      };

    default:
      return state;
  }
}
